import { apiClient } from '../apiClient';

export const PATHS = {
  INVITE_SMS: '/api/v5/invite-sms/',
} as const;

/**
 * Texts the user the app-download link from the transition screen (Sparta's
 * `sendMobileLink` → `/v5/invite-sms/`). Multipart form data with `phone_number`,
 * mirroring Sparta's FormData POST.
 *
 * The Content-Type override is required: apiClient defaults to
 * `application/json`, and axios v1's transformRequest serializes a FormData body
 * to JSON whenever the content-type is JSON — which the endpoint rejects
 * ("phone_number must be provided"). Setting `multipart/form-data` keeps the
 * body as form data.
 *
 * The missing `boundary` is NOT a problem (and unsetting the header instead
 * would be riskier — an `undefined` per-request header can let the JSON default
 * survive): axios's resolveConfig calls `setContentType(undefined)` for any
 * FormData body in a browser, so the browser regenerates the full
 * `multipart/form-data; boundary=…` header itself; React Native does the same.
 */
export async function sendMobileLink(phoneNumber: string): Promise<void> {
  const formData = new FormData();
  formData.append('phone_number', phoneNumber);
  await apiClient.post(PATHS.INVITE_SMS, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
